import React, { Component } from 'react'
import { 
  Button,
  Popover, Position, Tag
} from '@blueprintjs/core';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import ListPicker from 'components/ListPicker';
import SearchDateRangePicker from 'components/SearchDateRangePicker';
import ClientAutocomplete from 'components/ClientAutocomplete';
import TechnicianPicker from 'components/TechnicianPicker';
import moment from 'moment-timezone';
import { formatDateRange } from 'helpers/dateRange';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';
import DispatchViewBar from 'components/DispatchViewBar';
import PriorityTagPicker from 'components/PriorityTagPicker';
import { jobStatusOptions } from 'helpers/jobStatusOptions';

const options = jobStatusOptions();

@inject('store', 'jobStore', 'viewStore') @observer
class Assignment extends Component {

  @observable selectedClient = '';

  @action
  onPriorityChange(selections) {
    const selectedValues = selections
      .map((option) => option.value)
      .filter((value) => value !== "selectAll");
    const {
      props: {
        viewStore: {
          jobSearch
        }
      }
    } = this;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      where: {
        ...jobSearch.where,
        priority: selectedValues
      }
    }
  }

  onJobStatusChange(selections) {
    let selectedValues = selections.map((status) => status.value);
    let {
      props: {
        viewStore: {
          jobSearch
        }
      }
    } = this;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      where: {
        ...jobSearch.where,
        status: selectedValues
      }
    }
  }

  @action
  onDateRangeChange(range) {
    let {
      props: {
        viewStore: {
          jobSearch
        }
      }
    } = this;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      where: {
        ...jobSearch.where,
        start_date: { 
          gte: moment(range[0]).startOf('day').unix()
        },
        end_date: {
          lte: moment(range[1]).endOf('day').unix()
        }
      }
    }
    this.startDate = range[0];
    this.endDate = range[1];
    this.search()
  }

  onTechnicianChange(technicians) {
    let selectedValues = technicians.map((status) => status.value);
    let {
      props: {
        viewStore: {
          jobSearch
        }
      }
    } = this;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      where: {
        ...jobSearch.where,
        user_id: selectedValues
      }
    }
  }

  @action
  onClientSelect(client) {
    let {
      props: {
        viewStore: {
          jobSearch,
          jobSearch: {
            where: {
              client_id,
              ...whereWithNoClientId
            }
          }
        }
      }
    } = this;
    if (client) {
      this.props.viewStore.jobSearch = {
        ...jobSearch,
        where: {
          ...jobSearch.where,
          client_id: client.id
        }
      }
    } else {
      this.props.viewStore.jobSearch = {
        ...jobSearch,
        where: {
          ...whereWithNoClientId
        }
      }
    }
  }

  @action
  onJobNumberChange(e) {
    let {
      props: {
        viewStore: {
          jobSearch
        }
      }
    } = this;
    this.props.viewStore.jobSearch = {
      ...jobSearch,
      where: {
        ...jobSearch.where,
        event_number: e.target.value
      }
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.jobSearch.page = 1;
    viewStore.assignments();
  }

  changeView(view) {
    let { viewStore } = this.props;
    viewStore.dashboardSearch.view = view;
    viewStore.dashboard();
  }

  render() {
    const {
      viewStore: {
        jobSearch:{
          where
        }
      }
    } = this.props;
    let startDate = moment.unix(parseInt(where.start_date.gte)).toDate();
    let endDate = moment.unix(parseInt(where.end_date.lte)).toDate();
    return(
      <SearchFiltersToolbar
        header={<DispatchViewBar current="assignments" />}
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
      >
        <Popover
          minimal={true}
          content={
            <SearchDateRangePicker
              startDate={startDate}
              endDate={endDate}
              onChange={this.onDateRangeChange.bind(this)}
            />
          }
          position={Position.BOTTOM_LEFT}
          usePortal={true}
        >
          <Button
            className="filter-date"
            icon="calendar"
            rightIcon="caret-down"
            text={formatDateRange(startDate, endDate)}
          />
        </Popover>

        <ClientAutocomplete
          selectedClientId={where && where.client_id}
          onClientSelect={this.onClientSelect.bind(this)}
        />

        <TechnicianPicker
          selectedOptions={(where && where.user_id) || []}
          onChange={this.onTechnicianChange.bind(this)}
        />

        <Popover
          minimal={true}
          content={
            <ListPicker
              selectedOptions={(where && where.status) || []}
              options={options}
              onChange={this.onJobStatusChange.bind(this)}
            />
          }
          position={Position.BOTTOM_LEFT}
          usePortal={true} >
          <Button rightIcon='caret-down'>
            Status
            <span>&nbsp;</span>
            <Tag minimal={true} round={true}>{(where && where.status && where.status.length) || 0}</Tag>
          </Button>
        </Popover>

        <PriorityTagPicker
          selectedOptions={(where && where.priority) || []}
          onChange={this.onPriorityChange.bind(this)}
          includeSelectAll={true}
        />

        <input
          type="text"
          className="bp3-input"
          placeholder="Job Number"
          onChange={this.onJobNumberChange.bind(this)}
          defaultValue={where.event_number}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }

};

export default Assignment;